<template>
    <span class="icon-item" :class="'icon-item--' + theme">
        <span class="icon" :class="[iconClass]"></span>
    </span>
</template>

<script>
export default {
    name: "global-icon",
    props: {
        icon: {
            type: String
        },
        theme: {
            type: String,
            default: 'ghost',
            validator: function(value) {
                return ['brand', 'ghost'].indexOf(value) !== -1
            }
        },
    },
    computed: {
        iconClass() {
            if(/icon--/.test(this.icon)) {
                return this.icon
            } else {
                return 'icon--' + this.icon
            }
        }
    }
}
</script>

